import styled from 'styled-components'

export default styled.div`
  ${(props) => props.marginTop && `margin-top: ${props.marginTop};`}
  ${(props) => props.marginRight && `margin-right: ${props.marginRight};`}
  ${(props) => props.marginBottom && `margin-bottom: ${props.marginBottom};`}
  ${(props) => props.marginLeft && `margin-left: ${props.marginLeft};`}

  color: white;
  font-size: 0.9em;
  padding: 10px 20px;
  background-color: #ff3636;
  border-radius: 10px;
`
